import {
  TablePagination,
  tablePaginationClasses as classes
} from '@mui/material'
import { styled } from '@mui/system'

// const blue = {
//   200: '#A5D8FF',
//   400: '#3399FF'
// }
const grey = {
  50: '#F3F6F9',
  100: '#E7EBF0',
  200: '#E0E3E7',
  300: '#CDD2D7',
  400: '#B2BAC2',
  500: '#A0AAB4',
  600: '#6F7E8C',
  700: '#3E5060',
  800: '#2D3843',
  900: '#1A2027'
}
export const Root = styled('div')(
  ({ theme }) => `
              table {
                font-family: 'Raleway', sans-serif;
                font-size: 0.875rem;
                border-collapse: collapse;
                width: auto;
                padding:0.5rem;
              }
              
              td,
              th {
                border: 1px solid ${
                  theme.palette.mode === 'dark' ? grey[800] : grey[200]
                };
                text-align: left;
                padding: 12px;
              }
              
              th {
                background-color: ${
                  theme.palette.mode === 'dark' ? grey[900] : grey[100]
                };
              }
              `
)

export const CustomTablePagination = styled(TablePagination)(
  ({ theme }) => `
    & .${classes.toolbar} {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      gap: 0px;
      margin: 0px;
      padding: 0px 0 0 .3px;
    }

    /* Hide the "Rows per page:" label */
    & .${classes.selectLabel} {
      display: none;
    }

    /* Hide the rows per page dropdown */
    & .${classes.select} {
      display: none;
    }

    /* Reduce space between "1–4 of 4" and "< >" */
    & .${classes.spacer} {
      display: none; /* Removes extra spacing */
    }

    & .${classes.actions} {
      margin-left: 0px !important;
    }

    & .${classes.displayedRows} {
      margin-bottom: 0px;
      font-size: 17px;
      font-weight: 500;
      font-family: 'Poppins', sans-serif !important;
      letter-spacing: 0rem;
    }
  `
)
